// extracted by mini-css-extract-plugin
export default {"steps":"Steps__steps-rSMr","stepsCard":"Steps__stepsCard-aqWC","innerSvg":"Steps__innerSvg-uKCz"};